var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a984e02a1fff20b9b6d3050e29cac31333e2fbce"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kyc-web@kvika"]={id:"a984e02a1fff20b9b6d3050e29cac31333e2fbce"};
      